import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';
import { KendoLoading, QmActionButton } from '../../../components';
import * as enums from '../../../enums';
import { QueuePriority, TicketAction, ticketState } from '../../../enums';
import { blueButton, expand, redButton, scrollParent, scrollY, ticketButton, transparentButton } from '../Helpers';
import { ITicket } from '../model';
import { useTickets } from './context/TicketsContext';
import { IFilterSettings } from './Queue';
import TicketsFilter from './TicketsFilter';
import { Timer } from './Timer';

interface IQueueTicketBarProps {
    componentKey: number;
    componentText: string;
    ticketActionDisable: boolean;
    assignedTicket: ITicket | null;
    ticketActions: TicketAction[];
    tickets: ITicket[];
    ticketsSettings: IFilterSettings;
    setTicketSettings: Function;
    selectedTicket: ITicket | null;
    setSelectedTicket(ticket: ITicket): void;
    setLocationStatus(value: number): void;
    moveTicketToLocation(ticketId: number, newState: enums.TicketState): void;
    openSendToQueueModalWindow(ticket: ITicket): void;
    removeTicketFromQueue(ticketId: number, priority?: QueuePriority): void;
}

const QueueTicketBar: FC<IQueueTicketBarProps> = (props: IQueueTicketBarProps) => {
    const { allTickets } = useTickets();

    return (
        <fabric.StackItem styles={scrollParent}>
            <fabric.Stack.Item className="ticketTypeTitles">
                <fabric.Text variant="large">{props.componentText}</fabric.Text>
            </fabric.Stack.Item>

            <TicketsFilter componentKey={props.componentKey} ticketsSettings={props.ticketsSettings} setTicketsSettings={props.setTicketSettings} />
            <fabric.Stack styles={expand}>
                {!allTickets && <KendoLoading />}
                {!props.tickets || props.tickets.length === 0 ? (
                    <fabric.Stack style={{ textAlign: 'center' }}>-</fabric.Stack>
                ) : (
                    <fabric.Stack styles={scrollY}>
                        <>
                            {props.tickets &&
                                props.tickets.map(x => (
                                    <fabric.Stack
                                        key={x.id}
                                        style={{
                                            width: '100%',
                                            marginTop: '5px',
                                            marginBottom: '5px',
                                            background: '#fff',
                                            border: '1px solid #4A9491',
                                            borderRadius: 10
                                        }}
                                    >
                                        <fabric.DefaultButton
                                            style={{ border: 'none', background: 'white' }}
                                            onClick={() => {
                                                props.setSelectedTicket(x);
                                            }}
                                            styles={ticketButton}
                                            disabled={props.ticketActionDisable ? props.assignedTicket !== null : false}
                                        >
                                            <fabric.Stack style={{ flex: 1, textAlign: 'left' }}>
                                                <fabric.Text variant="large" style={{ margin: '1px' }}>
                                                    {x.number} {x.serviceName && '-'} {x.serviceName}
                                                </fabric.Text>
                                                <fabric.Text variant={'large'} style={{ margin: '1px' }}>
                                                    {x.patientFirstName} {x.patientLastName}
                                                </fabric.Text>
                                                <fabric.Text variant={'large'} style={{ margin: '1px' }}>
                                                    <Timer startFromTime={x.modifiedAt} />
                                                </fabric.Text>
                                                {x.visitTime && (
                                                    <fabric.Text variant={'large'} style={{ margin: '1px' }}>
                                                        Vizito laikas:&nbsp;
                                                        {x.visitTime}
                                                    </fabric.Text>
                                                )}
                                            </fabric.Stack>
                                        </fabric.DefaultButton>
                                        {props.selectedTicket && props.selectedTicket!.id == x.id && (
                                            <fabric.Stack horizontal>
                                                {props.ticketActions.indexOf(TicketAction.Invite) !== -1 && (
                                                    <QmActionButton
                                                        className="queueInviteButtons-1-of-3"
                                                        styles={blueButton}
                                                        onClick={() => {
                                                            props.setLocationStatus(0);
                                                            props.moveTicketToLocation(x.id, ticketState.Invited);
                                                        }}
                                                        text="Kviesti"
                                                    ></QmActionButton>
                                                )}
                                                {props.ticketActions.indexOf(TicketAction.Continue) !== -1 && (
                                                    <QmActionButton
                                                        className="queueInviteButtons-1-of-3"
                                                        styles={transparentButton}
                                                        onClick={() => {
                                                            props.setLocationStatus(0);
                                                            props.moveTicketToLocation(x.id, ticketState.Serviced);
                                                        }}
                                                        text="Tęsti"
                                                    ></QmActionButton>
                                                )}
                                                {props.ticketActions.indexOf(TicketAction.Send) !== -1 && (
                                                    <QmActionButton
                                                        className="queueInviteButtons-1-of-3"
                                                        styles={transparentButton}
                                                        onClick={() => props.openSendToQueueModalWindow(props.selectedTicket!)}
                                                        text="Siųsti"
                                                    ></QmActionButton>
                                                )}
                                                {props.ticketActions.indexOf(TicketAction.Remove) !== -1 && (
                                                    <QmActionButton
                                                        className="queueInviteButtons-1-of-3"
                                                        styles={redButton}
                                                        onClick={() => {
                                                            props.setLocationStatus(0);
                                                            props.removeTicketFromQueue(x.id, x.priorityLevel as QueuePriority);
                                                        }}
                                                        text="Pašalinti"
                                                    ></QmActionButton>
                                                )}
                                            </fabric.Stack>
                                        )}
                                    </fabric.Stack>
                                ))}
                        </>
                    </fabric.Stack>
                )}
            </fabric.Stack>
        </fabric.StackItem>
    );
};

export default QueueTicketBar;
